import React from 'react';
import PropTypes from 'prop-types';

import { formatPrice } from 'common/formatters';

/* eslint-disable max-len */
const SrPriceTooltip = ({ cx, cy, price }) => {
  return (
    <svg
      x={cx - 26}
      y={cy - 58}
      width="50"
      height="38"
      viewBox="0 0 50 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.7929 31.7071L26.2071 37.2929C25.8166 37.6834 25.1834 37.6834 24.7929 37.2929L19.2071 31.7071C18.5771 31.0771 19.0233 30 19.9142 30L31.0858 30C31.9767 30 32.4229 31.0771 31.7929 31.7071Z"
        fill="#007AFF"
      />
      <rect width="50" height="32" rx="4" fill="#007AFF" />
      <text
        x={43}
        y={5}
        dy={16}
        textAnchor="end"
        fontFamily="Greycliff"
        fontSize="12px"
        fontWeight="700"
        fill="#FFFFFF"
      >
        {formatPrice(price)}
      </text>
    </svg>
  );
};
/* eslint-enable max-len */

SrPriceTooltip.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
};

SrPriceTooltip.displayName = 'SrPriceTooltip';

export default SrPriceTooltip;
